import { useDispatch } from "react-redux";
import { workloadUrl } from "../../utils/constants";
import { IconButton } from "../../components/IconButton";
import HeaderLoadingIcon from "../common/HeaderLoadingIcon";
import { openContentUrl } from "screens/Root/actions/contentTabActions";
const HeaderWorkloadIcon = ({ loading, visible }) => {
    const dispatch = useDispatch();
    const handleClick = () => dispatch(openContentUrl(workloadUrl, "Task List"));
    return loading ? (<HeaderLoadingIcon />) : visible ? (<IconButton tooltip="Task List" onClick={handleClick} identification="header-workload">
      checklist
    </IconButton>) : null;
};
export default HeaderWorkloadIcon;
